var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":`${_vm.$t('vdcontainer.expire_date')}${_vm.check_detail_date}`,"placement":"top"}},[_c('span',{staticClass:"item-element-expire-date"},[_vm._v(" "+_vm._s(_vm.check_date)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }